import BranchService from "@/services/BranchService.js";

export default {
  namespaced: true,
  state: {
    loading: false,
    loadingOverlay: false,
    errors: null,
    branches: null,
    coordinates: null,
    branchesNearby: null,
    branchesNearbyPublic: null,
    specificBranch: null,
    featureBanner: null,
    featureBannerLength: 0,
    theme: null
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_OVERLAY(state, value) {
      state.loadingOverlay = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_BRANCHES(state, branches) {
      state.branches = branches;
    },
    SET_SPECIFIC_BRANCH(state, specificBranch) {
      state.specificBranch = specificBranch;
    },
    SET_BRANCHES_NEARBY(state, branchesNearby) {
      state.branchesNearby = branchesNearby;
    },
    SET_BRANCHES_NEARBY_PUBLIC(state, branchesNearbyPublic) {
      state.branchesNearbyPublic = branchesNearbyPublic;
    },
    SET_COORDINATES(state, coordinates) {
      state.coordinates = coordinates;
      localStorage.setItem("coordinates", JSON.stringify(coordinates));
    },
    SET_FEATURE_BANNER(state, featureBanner) {
      state.featureBanner = featureBanner;
    },
    SET_FEATURE_BANNER_LENGTH(state, featureBannerLength) {
      state.featureBannerLength = featureBannerLength;
    },
    SET_THEME(state, theme) {
      state.theme = theme;
    },
    resetCoordinates(state) {
      state.coordinates = null;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getBranches({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await BranchService.getBranches(request);
        commit("SET_BRANCHES", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getSpecificBranch({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response = await BranchService.getSpecificBranch(request);
        commit("SET_SPECIFIC_BRANCH", response);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getBranchesNearby({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await BranchService.getBranchesNearby(request);
        
        let openBranches = [];
        for (let index = 0; index < response.nearby.length; index++) {
          if (response.nearby[index].is_open) {
            openBranches.push(response.nearby[index])
          }
          openBranches.sort((a, b) => {
            if(a.distance < b.distance) return 1;
          })
        }
        
        let closeBranches = [];
        
        for (let index = 0; index < response.nearby.length; index++) {
          if (!response.nearby[index].is_open) {
            closeBranches.push(response.nearby[index])
          }
          closeBranches.sort((a, b) => {
            if(a.distance < b.distance) return 1;
          })
        }

        let branchesNearby = openBranches.concat(closeBranches);

        commit("SET_BRANCHES_NEARBY", branchesNearby);
        
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getBranchesNearbyPublic({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await BranchService.getBranchesNearbyPublic(request);

        let openBranches = [];
        for (let index = 0; index < response.nearby.length; index++) {
          if (response.nearby[index].is_open) {
            openBranches.push(response.nearby[index])
          }
          openBranches.sort((a, b) => {
            if(a.distance < b.distance) return 1;
          })
        }
        
        let closeBranches = [];
        
        for (let index = 0; index < response.nearby.length; index++) {
          if (!response.nearby[index].is_open) {
            closeBranches.push(response.nearby[index])
          }
          closeBranches.sort((a, b) => {
            if(a.distance < b.distance) return 1;
          })
        }

        let branchesNearbyPublic = openBranches.concat(closeBranches);

        commit("SET_BRANCHES_NEARBY", branchesNearbyPublic);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getFeaturedBannerList({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response = await BranchService.getFeaturedBannerList(request);
        commit("SET_FEATURE_BANNER", response);
        commit("SET_FEATURE_BANNER_LENGTH", response.feature_banner.length);
        commit("SET_THEME", response.theme);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    }
  },
  getters: {
    firstBranchNearby(state) {
      if (state.branchesNearby != null) {
        return state.branchesNearby[0];
      } else {
        return null;
      }
    },
    branchesNearby: state => state.branchesNearby,
    branchesNearbyPublic: state => state.branchesNearbyPublic
  }
};
